<mat-form-field class="w100" [class.hide-hint]="hideHint" *ngIf="fControl">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matDatepicker]="datePicker"
         [min]="min"
         [max]="$any(max)"
         [formControl]="fControl"
         [placeholder]="placeholder"
         [required]="required">
  <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
  <mat-datepicker #datePicker></mat-datepicker>
</mat-form-field>
